import { useEffect, useRef } from 'react'

import { useUpdateNodeInternals, useViewport } from '@xyflow/react'

import { useWorkflowLayoutContext } from './WorkflowLayoutContext'

export const useAutoMeasureNode = (nodeId: string) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const updateNodeInternals = useUpdateNodeInternals()
  const { zoom } = useViewport()
  const { onSizeNode } = useWorkflowLayoutContext()

  useEffect(() => {
    const element = containerRef.current
    if (!element) return

    const notify = () => {
      const rect = element.getBoundingClientRect()
      const scale = zoom || 1
      const width = rect.width / scale
      const height = rect.height / scale
      onSizeNode(nodeId, width, height)
      updateNodeInternals(nodeId)
    }

    notify()
    const observer = new ResizeObserver(() => notify())
    observer.observe(element)
    return () => observer.disconnect()
  }, [nodeId, onSizeNode, zoom, updateNodeInternals])

  return { containerRef }
}
